export default __webpack_public_path__ + "static/illusion-7d9ce53b5182bc8ccca29e605f65b2e4.png";